import React, { useState, useMemo } from 'react';
import { map } from 'lodash';
import PropTypes from 'prop-types';
import { Loader } from '@playbookux/playbook-web-core';

import { MENU_ITEMS } from './constants';
import useHeatmap from '../../../../../../core/hooks/use-heatmap';
import ClickMap from '../../../../../components/clickmap';
import Heatmap from '../../../../../components/heatmap';
import {
  QuestionOrder, Title, Container, ContainerHeader,
} from '../styles';
import {
  BaseImage,
  ContentHeatmap, Centered, MenuContainer, MenuFilter, MenuFilterItem,
} from './styles';

const HeatmapChart = ({ questionId, segmentId }) => {
  const { data = {}, loading, error } = useHeatmap(questionId, segmentId);
  const {
    firstClickQuestionHeatmap: {
      id, label, questionOrder, image, firstClickCoordinates = [],
    } = {},
  } = data;
  const [menuItemActive, setMenuItemActive] = useState(MENU_ITEMS.HEAT_MAP);

  const handleItemClick = (e, { name }) => setMenuItemActive(name);

  const transformedData = useMemo(() => firstClickCoordinates.map((item) => ({
    firstClickCoordinates: {
      x: item.x,
      y: item.y,
    },
  })), [firstClickCoordinates]);

  if (loading) {
    return (
      <Centered>
        <Loader />
      </Centered>
    );
  }

  if (error) {
    return (
      <Centered>
        <p>There was a problem loading this question</p>
        <p>
          [
          {questionId}
          ]
        </p>
      </Centered>
    );
  }

  return (
    <Container>
      <ContainerHeader>
        <QuestionOrder>{`Question ${questionOrder + 1}`}</QuestionOrder>
        <Title>{`${label} (First Click)`}</Title>
      </ContainerHeader>

      <MenuContainer textAlign="center">
        <MenuFilter secondary>
          {map(MENU_ITEMS, (item) => (
            <MenuFilterItem
              name={item}
              active={menuItemActive === item}
              onClick={handleItemClick}
            />
          ))}
        </MenuFilter>
      </MenuContainer>

      {menuItemActive === MENU_ITEMS.HEAT_MAP && (
        <ContentHeatmap>
          <Heatmap
            imageSrc={image}
            data={transformedData}
            id={id}
          />
        </ContentHeatmap>
      )}

      {menuItemActive === MENU_ITEMS.CLICK_MAP && (
        <ContentHeatmap>
          <ClickMap
            data={transformedData}
            imageSrc={image}
            id={id}
          />
        </ContentHeatmap>
      )}

      {menuItemActive === MENU_ITEMS.IMAGE && (
        <ContentHeatmap>
          <BaseImage src={image} alt="heatmap" />
        </ContentHeatmap>
      )}

    </Container>
  );
};

HeatmapChart.propTypes = {
  questionId: PropTypes.string.isRequired,
  segmentId: PropTypes.arrayOf(PropTypes.string),
};

HeatmapChart.defaultProps = {
  segmentId: null,
};

export default HeatmapChart;
